export default __webpack_public_path__ + "static/underline-9d4d6e52663393f672c44aa7dc601326.svg";